export const client = require('contentful').createClient({
  space: '8t4hr9hmjs2u',
  accessToken: 'QbBZr3iMCy9S5XWsgacQ9Cm1acWK2iqx5By9G7ju9VU'
})


export const getBlogPosts = () => client.getEntries().then(response => response.items)